import { useStore } from 'Resident/store'
import React, { createContext, useContext, useEffect, useMemo } from 'react'
import BottomDrawer from 'shared/components/BottomDrawer'
import Video from 'shared/components/Video'
import { ReactComponent as AppStore } from 'shared/assets/icons/appstore-black-filled.svg'
import Button from 'shared/components/Button'
import { useMediaQuery } from '@react-hook/media-query'
import WelcomeModal from '../WelcomeModal'
import { ReactComponent as Tick } from 'shared/assets/icons/resident-welcome-tick.svg'
import { APP_STORE_LINK } from 'shared/constants'

function WelcomeBottomDrawer() {
  const { appData, welcomeDrawer, setWelcomeDrawer } = useStore()
  const isMobile = useMediaQuery('(max-width: 1023px)')

  const link = useMemo(()=>{
    if(appData && appData.invite){
      const { invitation_link_short_ios } = appData.invite
      return invitation_link_short_ios || APP_STORE_LINK
    } else {
      return APP_STORE_LINK
    }
  }, [appData])

  return (
    <>
      {appData && isMobile && (
        <BottomDrawer
          className=""
          isOpen={welcomeDrawer.opened}
          onClose={() => {
            setWelcomeDrawer({ opened: false })
          }}
        >
          <div className="text-[17px] text-center">Upgrade to an Immersive Experience!</div>
          <div className="mt-[12px]">
            {' '}
            {appData.config ? (
              <Video
                className="rounded-[4px] overflow-hidden"
                src={appData.config.residents_instruction_video}
                poster={appData.config.resident_welcome_video_thumbnail}
              />
            ) : null}
          </div>
          <div className="mt-[22px]">
            <div className="flex items-center">
              <Tick /> <span className="ml-[16px] lg:text-[18px] font-light">Compatible with Pro devices</span>
            </div>
            <div className="flex mt-[8px] items-center">
              <Tick /> <span className="ml-[16px] lg:text-[18px] font-light">Applicable when in-unit</span>
            </div>
          </div>
          <div className="flex justify-center items-center mt-[32px]">
            <a href={link} target="_blank" className="ml-[18px]" rel="noreferrer">
              <AppStore />
            </a>
          </div>
        </BottomDrawer>
      )}
      {appData && !isMobile && (
        <WelcomeModal onClose={() => setWelcomeDrawer({ opened: false })} opened={welcomeDrawer.opened} />
      )}
    </>
  )
}

export default WelcomeBottomDrawer
